// src/store/canvasObjectSlice.ts
import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  shapeId: null,
  previewEnabled: false,

  // --
  intro: true,
  color: "#ffffff",
  isLogoTexture: true,
  isFullTexture: false,
  logoDecal: '',
  fullDecal: '',
  frontPreview: null,
  backPreview: null,
  frontMockupPreview: true,
};

const designPreviewReducer = createSlice({
  name: "canvasObject",
  initialState,
  reducers: {
    setSelectedObjectId: (state, action) => {
      state.shapeId = action.payload;
    },
    togglePreview: (state) => {
      state.previewEnabled = !state.previewEnabled;
    },
     setColor: (state, action) => {
      state.color = action.payload;
    },
    // setLogoDecal: (state, action) => {
    //   state.logoDecal = action.payload;
    //   state.frontPreview = action.payload.frontPreview;
    //   state.backPreview = action.payload.backPreview;
    // },

     setPreviewImages: (state, action) => {
      state.frontPreview = action.payload.frontPreview;
      state.backPreview = action.payload.backPreview;
    },
    setFrontCanvasJSON: (state, action) => {
      state.frontCanvasJSON = action.payload;
    },
    setBackCanvasJSON: (state, action) => {
      state.backCanvasJSON = action.payload;
    },
    setFrontMockupPreviewToggle: (state, action) => {
      state.frontMockupPreview = action.payload;
    },
  },
});

export const {
  setSelectedObjectId,
  setColor,
  togglePreview,
  // setLogoDecal,
  setPreviewImages,
  setFrontCanvasJSON,
  setBackCanvasJSON,
  setFrontMockupPreviewToggle
} = designPreviewReducer.actions;
export default designPreviewReducer.reducer;
